// eslint-disable-next-line import/prefer-default-export
export const BG_TIMEZONE = 'America/New_York';
